
class TableMatrix {

  constructor(object) {
    // const d = new Date();
    // console.log("[TableMatrix] New TableMatrix creation!");
    if (object === undefined) {
      this._obj = [[undefined]];
    } else if ((typeof object === "object") && (!Array.isArray(object))) {
      this._obj = [[{ ...object }]];
    } else if (Array.isArray(object)) {
      this._obj = object.map(rowElem => {
        if (rowElem === undefined) {
          return [ undefined ];
        } else if ((typeof rowElem === "object") && (!Array.isArray(rowElem))) {
          return [{ ...rowElem }];
        } else if (Array.isArray(rowElem)) {
          return rowElem.map((content) => {
            if (content === undefined) {
              return undefined;
            } else if ((typeof content === "object") && (!Array.isArray(content))) {
              return { ...content };
            } else if (Array.isArray(content)) {
              return content.map((contentSubcontent) => contentSubcontent);
            } else {
              return content;
            }
          });
        } else {
          return [ rowElem ]
        }
      });
    } else {
      this._obj = [[ object ]];
    } 
    // console.log("[TableMatrix] New TableMatrix created! Creation time : ", (new Date() - d));
  }

  inverse() {
    this._obj = (new TableMatrix(this.getColumns())).getRows();
  }

  getMaxRowsLength() {
    return this.getRows().length;
  }

  getMaxColumnsLength() {
    return this.getRows().map(rowElem => {
      return rowElem.length;
    }).reduce((previousValue, currentValue) => {
      return previousValue > currentValue ? previousValue : currentValue;
    }, 0);
  }

  getRows() {
    return this._obj;
  }

  getRow(rowIndex) {
    return this.getRows()[rowIndex];
  }

  getColumns() {
    const columnsLength = this.getMaxColumnsLength();
    const returnedColumns = [];
    for (let i=0; i<columnsLength; i++) {
      returnedColumns.push(this.getColumn(i));
    }
    return returnedColumns;
  }

  getColumn(columnIndex) {
    return this.getRows().map(rowElem => {
      return rowElem[columnIndex];
    });
  }

}

export default TableMatrix